import styled from "styled-components";
import { Row } from "react-bootstrap";

export const StyledReportHeader = styled(Row)`
  display: grid;
  grid-template-columns: 50% [col-start] 25% [col-start];
  justify-content: end;
  align-items: center;

  .lab-report-title {
    max-width: 430px;
    font-size: var(--font-size-base);
    @media screen and (max-width: 576px) {
      font-weight: 500;
      background: transparent;
      width: auto;
      padding: 0px;
    }
  }
  .date-box {
    justify-self: end;
    width: 100px;
    height: 24px;
    background: #b0e1fb;
    border-radius: 6px;
    color: var(--text-color-dark);
    font-size: var(--font-size-xs);
    @media screen and (max-width: 425px) {
      width: 80px;
      padding: 0px;
    }
  }
`;
